"use client";

import { c as _c } from "react/compiler-runtime";
import { Plus, Minus, ArrowRight, LayoutGrid } from "lucide-react";
import { LandvestHandoffLink } from "@/components/layout/LandvestHandoffLink";
import type { MegaMenuConfig } from "@/lib/navigation";
interface MobileAccordionProps {
  menu: MegaMenuConfig;
  isOpen: boolean;
  onToggle: () => void;
  onItemClick: () => void;
}
const ITEM_CLASS = "pl-0.5 text-[17px] font-medium text-surface/[0.88] hover:text-neon transition-colors";

/**
 * One menu as an accordion: the hub as a pill on top, then each column's
 * heading and entries. The featured card and the further strip links become
 * plain entries. The Branchen chips stay desktop-only (the hub lists them).
 */
export function MobileAccordion(t0) {
  const $ = _c(25);
  const {
    menu,
    isOpen,
    onToggle,
    onItemClick
  } = t0;
  let t1;
  if ($[0] !== menu.featuredCard) {
    t1 = menu.featuredCard ? [{
      label: menu.featuredCard.badge ?? menu.featuredCard.headline,
      href: menu.featuredCard.ctaHref
    }] : [];
    $[0] = menu.featuredCard;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== menu.bottomStrip?.links) {
    t2 = menu.bottomStrip?.links ?? [];
    $[2] = menu.bottomStrip?.links;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = [...t1, ...t2];
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const extraLinks = t3;
  let t4;
  if ($[7] !== menu.triggerLabel) {
    t4 = <span className="text-2xl font-bold tracking-[-0.01em] text-surface">{menu.triggerLabel}</span>;
    $[7] = menu.triggerLabel;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isOpen) {
    t5 = isOpen ? <Minus className="w-6 h-6 text-surface/70" aria-hidden="true" /> : <Plus className="w-6 h-6 text-surface/70" aria-hidden="true" />;
    $[9] = isOpen;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isOpen || $[12] !== onToggle || $[13] !== t4 || $[14] !== t5) {
    t6 = <button onClick={onToggle} className="flex items-center justify-between w-full min-h-16 text-left" aria-expanded={isOpen}>{t4}{t5}</button>;
    $[11] = isOpen;
    $[12] = onToggle;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== extraLinks || $[17] !== isOpen || $[18] !== menu.bottomStrip || $[19] !== menu.sections || $[20] !== onItemClick) {
    t7 = isOpen && <div className="flex flex-col gap-[18px] pt-1 pb-6">{menu.bottomStrip && <LandvestHandoffLink href={menu.bottomStrip.primary.href} onClick={onItemClick} className="self-start flex items-center gap-2 rounded-full bg-neon px-4 py-2.5 text-sm font-extrabold text-primary hover:bg-neon/80 transition-colors"><LayoutGrid className="w-[15px] h-[15px]" aria-hidden="true" />{menu.bottomStrip.primary.label}</LandvestHandoffLink>}{menu.sections.map(section => <div key={section.id} className="flex flex-col gap-2.5">{section.title && (section.href ? <LandvestHandoffLink href={section.href} onClick={onItemClick} className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.12em] text-neon">{section.title}<ArrowRight className="w-3.5 h-3.5" aria-hidden="true" /></LandvestHandoffLink> : <span className="text-xs font-bold uppercase tracking-[0.12em] text-neon">{section.title}</span>)}{section.items?.map(item => <LandvestHandoffLink key={item.id} href={item.href} onClick={onItemClick} className={ITEM_CLASS}>{item.label}</LandvestHandoffLink>)}</div>)}{extraLinks.length > 0 && <div className="flex flex-col gap-2.5">{extraLinks.map(link => <LandvestHandoffLink key={link.href} href={link.href} onClick={onItemClick} className={ITEM_CLASS}>{link.label}</LandvestHandoffLink>)}</div>}</div>;
    $[16] = extraLinks;
    $[17] = isOpen;
    $[18] = menu.bottomStrip;
    $[19] = menu.sections;
    $[20] = onItemClick;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t6 || $[23] !== t7) {
    t8 = <div className="border-b border-surface/[0.12]">{t6}{t7}</div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}